import { Button } from "@/components/ui/button";
import { Pencil, Check, GripVertical } from "lucide-react";
import { cn } from "@/lib/utils";

interface EditModeToggleProps {
  isEditMode: boolean;
  onToggle: () => void;
}

export const EditModeToggle = ({ isEditMode, onToggle }: EditModeToggleProps) => {
  return (
    <div className="flex items-center gap-3">
      {isEditMode && (
        <div className="flex items-center gap-2 px-3 py-1.5 rounded-lg bg-primary/10 text-primary text-sm animate-fade-in">
          <GripVertical className="h-4 w-4" />
          <span className="font-medium">Arrastra las tarjetas para reordenar</span>
        </div>
      )}
      <Button
        variant={isEditMode ? "default" : "outline"}
        size="sm"
        onClick={onToggle}
        className={cn(
          "gap-2 transition-all",
          isEditMode && "bg-primary text-primary-foreground shadow-lg"
        )}
      >
        {isEditMode ? (
          <>
            <Check className="h-4 w-4" />
            Guardar Layout
          </>
        ) : (
          <>
            <Pencil className="h-4 w-4" />
            Editar Layout
          </>
        )}
      </Button>
    </div>
  );
};
